import { TextField } from "@mui/material";
import styles from "./customersignup.module.css";

// Shown when the email already has accounts and a new password was entered:
// the backend emailed a code, and the new password applies to all accounts once it is confirmed.
const VerifyCodeBox = ({ message, code, setCode, onResend }) => (
  <div className={styles.VerifyBox} role="status">
    <p className={styles.VerifyText}>{message}</p>
    <TextField
      classes={{ root: styles.inputRoot }}
      fullWidth
      label="Verification code*"
      variant="outlined"
      value={code}
      onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
      inputProps={{ inputMode: "numeric", autoComplete: "one-time-code" }}
    />
    <button type="button" className={styles.VerifyResendBU} onClick={onResend}>Send a new code</button>
  </div>
);

export default VerifyCodeBox;
